import { render, staticRenderFns } from "./user-followup.vue?vue&type=template&id=2f37f5bd&scoped=true"
import script from "./user-followup.vue?vue&type=script&lang=js"
export * from "./user-followup.vue?vue&type=script&lang=js"
import style0 from "./user-followup.vue?vue&type=style&index=0&id=2f37f5bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f37f5bd",
  null
  
)

export default component.exports